import { Avatar } from "./avatar";

interface Props {
  size: number;
  name: string;
  url?: string;
  className?: string;
}

export function UserAvatar({ name, url, size, ...props }: Props) {
  return (
    <Avatar
      {...props}
      src={url?.startsWith("/") ? import.meta.env.VITE_API_URL + url : url}
      fallback={getInitials(name)}
      size={size}
    />
  );
}

function getInitials(name: string) {
  const parts = name.trim().split(" ");
  const first = parts[0]?.charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1]?.charAt(0) : "";
  return first + last;
}
